// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";

function t(headingColorOpt, colorOpt, param) {
  var headingColor = headingColorOpt !== undefined ? headingColorOpt : Theme__Color$PrezzeeRibbon.gray800;
  var color = colorOpt !== undefined ? colorOpt : Theme__Color$PrezzeeRibbon.gray600;
  return {
          headingColor: headingColor,
          color: color
        };
}

export {
  t ,
}
/* Theme__Color-PrezzeeRibbon Not a pure module */
